export const formFields = [
  {
    section: "General Information",
    name: "dscScheduleName",
    label: "Schedule",
    fieldLabel: "DSC Schedule Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [1, 1],
  },
  {
    section: "General Information",
    name: "dscDescription",
    label: "Description",
    fieldLabel: "DSC Description",
    type: "text",
    options: { maxLength: { value: 40, message: "MAXLENGTH_40" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [2, 1],
  },
  {
    section: "General Information",
    name: "dscBasis",
    label: "Basis",
    fieldLabel: "DSC Basis",
    type: "dropdown",
    dropdownCondition: "*Valid values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [3, 1],
  },
  {
    section: "General Information",
    name: "dscStepCount",
    label: "Steps",
    fieldLabel: "DSC Step Count",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [4, 1],
  },
  {
    section: "General Information",
    name: "dsdStepNumber",
    label: "Step Number",
    fieldLabel: "DSD Step Number",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
      required: { value: true, message: "REQUIRED" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 1],
  },
  {
    section: "General Information",
    name: "dsdAccumComponentCode",
    label: "Accum Component Code",
    fieldLabel: "DSD Accum Component Code",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [6, 1],
  },
  {
    section: "General Information",
    name: "dsdAccumWMadTimestmp",
    label: "After Adj Time",
    fieldLabel: "DSD Accum w/MAD Timestmp?",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 1],
  },
  {
    section: "Deduct",
    name: "dsdMbrDeductibleAmount",
    label: "Deduct: Individual",
    fieldLabel: "DSD Mbr Deductible Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 1],
  },
  {
    section: "Deduct",
    name: "dsdFamilyIndividualAmt",
    label: "Deduct: Family Individual",
    fieldLabel: "DSD Family Individual Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 1],
  },
  {
    section: "Deduct",
    name: "dsdFamDeductibleAmount",
    label: "Deduct: Family",
    fieldLabel: "DSD Fam Deductible Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 1],
  },
  {
    section: "Deduct",
    name: "dsdPricingTableFlag",
    label: "Copay Pat Pay Table",
    fieldLabel: "DSD Pricing Table Flag",
    type: "dropdown",
    dropdownCondition: "Valid values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 1],
  },
  {
    section: "Copay Amount",
    name: "dsdBrandCopayAmount",
    label: "Copay Amount: Brand",
    fieldLabel: "DSD Brand Copay Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99999.99, message: "MAX_99999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 1],
  },
  {
    section: "Copay Amount",
    name: "dsdGenericCopayAmount",
    label: "Copay Amount: Generic",
    fieldLabel: "DSD Generic Copay Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99999.99, message: "MAX_99999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 2],
  },
  {
    section: "Copay Percent",
    name: "dsdBrandPercentAmt",
    label: "Copay Percent: Brand",
    fieldLabel: "DSD Brand Percent Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 1],
  },
  {
    section: "Copay Percent",
    name: "dsdGenericPercentAmt",
    label: "Copay Percent: Generic",
    fieldLabel: "DSD Generic Percent Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 2],
  },
  {
    section: "Section 6",
    name: "dsdPercentBasis",
    label: "Percent Basis",
    fieldLabel: "DSD Percent Basis",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 1],
  },
  {
    section: "Section 6",
    name: "dsdCopayDeductibleFlag",
    label: "Update",
    fieldLabel: "DSD Copay/Deductible Flag",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 1],
  },
  {
    section: "Section 6",
    name: "dsdCrossOverFlag",
    label: "Cross Over",
    fieldLabel: "DSD Cross Over Flag",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 1],
  },
  {
    section: "Section 6",
    name: "dsdMessageCode",
    label: "Message Code",
    fieldLabel: "DSD Message Code",
    type: "lookup",
    externalProgram: { default: "RCMSG002" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "dsdMessageCode",
            target: "code",
            legacy:"msgMessageCde"
          },
        ],
      },
    },

    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 1],
  },
  {
    section: "Section 6",
    name: "dsdMessageType",
    label: "Message Type",
    fieldLabel: "DSD Message Type",
    type: "dropdown",
    dropdownCondition: "Valid Deductible Values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 3],
  },
  {
    section: "Section 6",
    name: "planCode",
    label: "Plan Override",
    fieldLabel: "Plan Code",
    type: "lookup",
    externalProgram: { default: "RCPLN018" },
    params: {
      lookupType: "local",
      viewType:"legacy",
      fieldMapping: {
        default: [
          { source: "planCode", target: "planCode",legacy:"planCode" },
          { source: "planEffDate", 
            resolver:"formatDateForPresto",
            legacy:"planEffDate",
            target: "planEffDate" },
          { source: "planName", target: "planName",legacy:"planName" },
        ],
      },
    },
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 1],
  },
  {
    section: "Section 6",
    name: "planEffDate",
    label: "From Date",
    fieldLabel: "Plan Eff Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [22, 2],
  },
  {
    section: "Section 6",
    name: "planName",
    label: "",
    fieldLabel: "Plan Name",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [21, 3],
  },
  {
    section: "Section 6",
    name: "dsdSendFlag",
    label: "Send",
    fieldLabel: "OPD Send Flag",
    type: "dropdown",
    dropdownCondition: "Yes & No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 1],
  },
  {
    section: "Section 6",
    name: "dsdIntPharmAndMedical",
    label: "Integrated Pharmacy and Medical",
    fieldLabel: "OPD Int Pharm and Medical",
    type: "dropdown",
    dropdownCondition: "Deductible + OOP Int List",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [24, 1],
  },
  {
    section: "Deductible by Family Type (Header)",
    Layout: "Table Format",
    label: "Type",
    type: "label",
    position: [25, 1],
  },
  {
    section: "Deductible by Family Type (Header)",
    Layout: "Table Format",
    label: "Deductible",
    type: "label",
    position: [25, 2],
  },
  {
    section: "Deductible by Family Type (Header)",
    name: "dsdDedAmtCardSpouse",
    label: "3 Cardholder & Spouse",
    fieldLabel: "DSD Ded Amt: Card+Spouse",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [26, 1],
  },
  {
    section: "Deductible by Family Type (Header)",
    name: "dsdDedAmtCardDeps",
    label: "4 Cardholder & Dependents",
    fieldLabel: "DSD Ded Amt: Card+Deps",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [27, 1],
  },
  {
    section: "Deductible by Family Type (Header)",
    name: "dsdDedAmtSpouseDeps",
    label: "5 Spouse & Dependents",
    fieldLabel: "DSD Ded Amt: Spouse+Deps",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [28, 1],
  },
  {
    section: "Deductible by Family Type (Header)",
    name: "dsdDedAmtDeps",
    label: "6 Dependents",
    fieldLabel: "DSD Ded Amt: Deps",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [29, 1],
  },
  {
    section: "Deductible by Family Type (Header)",
    name: "dsdDedAmtSpouseOnly",
    label: "7 Spouse Only",
    fieldLabel: "DSD Ded Amt: Spouse Only",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 1],
  },
  {
    section: "Deductible by Family Type (Header)",
    name: "dsdDedAmtMbr1",
    label: "8 Member + 1",
    fieldLabel: "DSD Ded Amt: Mbr+1",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [31, 1],
  },
  {
    section: "Deductible by Family Type (Header)",
    name: "dsdDedAmtCard1",
    label: "9 Cardholder + 1 Dependent",
    fieldLabel: "DSD Ded Amt: Card+1",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [32, 1],
  },
  {
    section: "Deductible by Family Type",
    name: "dsdDedAmtCard2",
    label: "A Cardholder + 2 Dependent",
    fieldLabel: "DSD Ded Amt: Card+2",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [33, 1],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [34, 1],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [34, 2],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [34, 3],
  },
];
